import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/models';

export const StudentList: React.FC = () => {
  // const students = useSelector((state: RootState) => state.classroom.students); // TODO use this later
  const classroom = useSelector((state: RootState) => state.reports.roster.ui.selections.classroom);
  const studentsRoster = useSelector((state: RootState) => state.reports.roster.data.student);
  const students = studentsRoster.filter((s: {classroom_id: string[]}) => s.classroom_id.includes(`${classroom.id}`)).map((s: {
    id: string,
    first_name: string,
    last_name: string,
    grade: number
  }) => ({
    ...s,
    firstName: s.first_name,
    lastName: s.last_name,
  }));
  const sortedStudents = [...students].sort((a, b) => a.lastName.localeCompare(b.lastName));
  return (
    <ul className='student-list list-unstyled'>
      {sortedStudents.map((student) => (
        <li className='student-list-item bg-dark-subtle px-2 py-1 mb-2 rounded-1' key={`aec-student-${student.id}`}>
          {student.firstName} {student.lastName}
        </li>
      ))}
    </ul>
  );
};

export default StudentList;